import React, { ReactNode } from 'react';

import { Box, HStack, Icon, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import Link, { IInLineLinkProps, ILinkProps } from 'components/link';
import { NewBadgeIcon } from 'pages/account/icons/new-badge-icon';
import { CustomEventNames } from 'state/amplitude';
import { primitive } from 'styles/constants/primitives';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

const StyledLink = Link.withConfig({
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  borderBottomColor: `${Styles.color.grey.four}`,
  width: '100%',
  color: Styles.color.grey.one,
  paddingX: '0',
  paddingY: '5',
  _web: {
    cursor: 'pointer',
  },
});

const BadgeContainer = HStack.withConfig({
  width: '$14',
  marginLeft: '$1',
  padding: '$1',
  paddingRight: '$2',
  alignContent: 'center',
  backgroundColor: '#D1FAE5',
  borderRadius: 5,
});

interface AccountLinkProps {
  link: string;
  label: string;
  testID?: string;
  showNewBadge?: boolean;
  leftIcon: ReactNode;
  linkProps?: IInLineLinkProps | ILinkProps;
}

export const AccountLink = ({
  link,
  label,
  leftIcon,
  linkProps,
  testID,
  showNewBadge,
}: AccountLinkProps) => {
  const { formatMessage } = useIntl();

  const Badge = () => (
    <BadgeContainer>
      <Box width={'$4'} alignSelf={'center'}>
        <NewBadgeIcon />
      </Box>
      <Text fontSize={'sm'}>{formatMessage({ id: 'new' })}</Text>
    </BadgeContainer>
  );

  return (
    <StyledLink
      to={link}
      eventName={CustomEventNames.BUTTON_CLICK_ACCOUNT_INFO}
      testID={testID}
      color={primitive.bk.$bbqBrown}
      justifyContent="space-between"
      {...linkProps}
    >
      <HStack alignItems={'center'}>
        <Box>{leftIcon}</Box>
        <Text marginLeft={'$3'} alignContent={'center'}>
          {label}
        </Text>
        <Box>{showNewBadge && <Badge />}</Box>
      </HStack>
      <Icon variant="next" ml="$1" width="4" {...hiddenAccessibilityPlatformProps} />
    </StyledLink>
  );
};
